// Provider display tokens are brand names and must NEVER be translated.
export const PROVIDERS = {
  openai: { label: "ChatGPT", hex: "#10A37F" },
  perplexity: { label: "Perplexity", hex: "#0EA5C4" },
  gemini: { label: "Gemini", hex: "#8B5CF6" },
};

// TODO: replace with the real business WhatsApp number (international format, no +).
export const WHATSAPP_NUMBER = "0534 332 31 11";
export const WHATSAPP_MSG = "Merhaba, AI Marka Radar hakkında bilgi almak istiyorum";
export const waLink = () =>
  `https://wa.me/905343323111`;

export const SECTORS = [
  "Sağlık & Klinik",
  "Gayrimenkul & İnşaat",
  "Restoran & Kafe",
  "Otel & Turizm",
  "Gece Hayatı & Eğlence",
  "Güzellik & Kuaför",
  "Avukat & Danışmanlık",
  "Oto Galeri & Servis",
  "E-ticaret",
  "Yerel Hizmetler",
];

// Example buying-intent questions a real customer would ask an AI, per sector.
export const SECTOR_QUESTIONS = {
  "Sağlık & Klinik": "İstanbul'da en iyi saç ekimi kliniği hangisi?",
  "Gayrimenkul & İnşaat": "Bodrum'da lüks villa için en güvenilir emlak firması hangisi?",
  "Restoran & Kafe": "İstanbul'da aileyle gidilecek en iyi restoran hangisi?",
  "Otel & Turizm": "Kapadokya'da balayı için en iyi otel önerisi nedir?",
  "Gece Hayatı & Eğlence": "İstanbul'da bu hafta sonu gidilecek en iyi gece kulübü?",
  "Güzellik & Kuaför": "Ankara'da en iyi güzellik merkezi ve kuaför hangisi?",
  "Avukat & Danışmanlık": "İstanbul'da ticaret hukuku için en iyi avukat kim?",
  "Oto Galeri & Servis": "İkinci el araba almak için güvenilir bir galeri önerir misin?",
  "E-ticaret": "En kaliteli organik cilt bakım ürünleri hangi markada?",
  "Yerel Hizmetler": "Yakınımdaki en iyi kombi servisi hangisi?",
};

export const scoreColor = (score) => {
  if (score === null || score === undefined) return { hex: "#A1A1AA", bghex: "#F4F4F5", label: "—" };
  if (score >= 60) return { hex: "#059669", bghex: "#D1FAE5", label: "Güçlü" };
  if (score >= 30) return { hex: "#D97706", bghex: "#FEF3C7", label: "Orta" };
  return { hex: "#E11D48", bghex: "#FFE4E6", label: "Zayıf" };
};

export const INTENT_LABELS = {
  general: "Genel",
  comparison: "Karşılaştırma",
  price: "Fiyat",
  trust: "Güven",
  procedure: "İşlem",
};
